<template>
  <div style="width: 100%;">
    <span class="users-main"
          :class="{'users-main_container' : hasJudgePollUserOptions,
                   'users-main_noOptsContainer' : !hasJudgePollUserOptions}">
      <figure class="avatar-container multiple-avatar"
              :class="{'avatar-container_noOpts' : !hasJudgePollUserOptions,
                       'avatar-container_Opts' : hasJudgePollUserOptions}"
              :data-balloon="user.userName"
              data-balloon-pos="down-left">
        <img :src="avatar(user.avatar)"
             @error="altImg"
             alt="Co-Owner Avatar">
      </figure>
      <div class="name-container"
           :class="{'name-container_Opts' : hasJudgePollUserOptions}">
        <h2 class="name-container_title">
          {{ userName }}
        </h2>
        <p class="name-container_info"
           v-for="(text, index) in texts"
           :key="index">
          {{ formatInfo(text) }}
        </p>
      </div>
    </span>
  </div>
</template>

<script>
import imageProxy from '@/libs/image-proxy'

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    texts: {
      type: Array,
      required: true
    },
    hasJudgePollUserOptions: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    userName: function () {
      return this.user.fullName ?? this.user.userName
    }
  },
  methods: {
    avatar: function (url) {
      return imageProxy.thumbnailXl(url)
    },
    altImg: function (e) {
      e.target.src = 'https://www.engineering.com/static/purple-logo-icon.svg'
    },
    formatInfo: function (str) {
      const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s/0-9]*$/g
      if (phoneRegex.test(str)) {
        return this.formatPhoneNumber(str)
      } else {
        return this.formatCountryCode(str)
      }
    },
    formatPhoneNumber: function (str) {
      const cleaned = ('' + str).replace(/\D/g, '')
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        const intlCode = (match[1] ? '+1 ' : '')
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
      }
      return str
    },
    formatCountryCode: function (str) {
      // US only
      if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(str)) {
        return str
      }
      // CAN only
      if (/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(str)) {
        return str.toUpperCase().replace(/\W/g, '').replace(/(...)/, '$1 ')
      }
      return str
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .users-main {
    align-items: center;
    margin: 2rem 0 0 0;
    display: flex;
    &_container {
      flex-direction: row;
      justify-content: space-between;
      padding: 0 1rem;
    }
    &_noOptsContainer {
      flex-direction: column;
      justify-content: center;
    }
  }
  .avatar-container {
    height: auto;
    display: inline-block;
    z-index: 4;
    overflow: visible;
    @include mobile{
      width: 9rem;
    }
    &_noOpts {
      width: 12rem;
    }
    &_Opts {
      width: 4rem;
      margin-right: .625rem;
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  .name-container {
    &_Opts {
      width: 100%;
    }
    &_title {
      font-size: 1rem;
      font-weight: 800;
      font-family: $primary-font;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 180px;
      margin-top: 5px;
      margin-bottom: 5px;
      @include mobile {
        max-width: 91px;
        font-size: 0.75rem;
      }
    }
    &_info {
      font-size: 0.8rem;
      text-transform: uppercase;
    }
    color: black;
  }

  .multiple-avatar{
    position: relative;
  }
</style>
